import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative overflow-hidden h-48">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {article.isHot && (
          <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}
        {article.isNew && (
          <span className="absolute top-3 right-3 px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
            最新
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 leading-snug">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="whitespace-nowrap">
              <i className="ri-time-line mr-1"></i>{article.publishDate}
            </span>
            <span className="whitespace-nowrap">
              <i className="ri-eye-line mr-1"></i>
              {article.readCount > 10000
                ? `${(article.readCount / 10000).toFixed(1)}万`
                : article.readCount}
            </span>
          </div>
          <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
            {article.category === 'entertainment' ? '娱乐圈' :
             article.category === 'social' ? '社会热点' :
             article.category === 'tech' ? '科技数码' :
             article.category === 'finance' ? '财经商业' :
             article.category === 'sports' ? '体育竞技' : article.category}
          </span>
        </div>
      </div>
    </Link>
  );
}